import { defineMessages } from "react-intl";

const PREFIX = "UseDepartmentsHook";
export default defineMessages({
  deleted: {
    id: `${PREFIX}.deleted`,
    defaultMessage: "Deleted",
  },
});
